import React from "react";
import Link from "next/link";
import styles from "./blog_hero_simple.module.scss";

export const BlogHeroSimple = ({
  forCategory,
  forSearch,
  forTag,
  title,
  searchKey,
}) => {
  return (
    <section className={styles.blog_hero_simple}>
      <div className="container">
        <div className={styles.wrapper}>
          {forTag && (
            <>
              <div>Tag</div>
              <h2 className={styles.title}>{title}</h2>
            </>
          )}
          {forCategory && (
            <>
              <div>Category</div>
              <h2 className={styles.title}>{title}</h2>
            </>
          )}

          {forSearch && (
            <>
              <div className={styles.breadcrumbs}>
                <Link legacyBehavior href="/blog">
                  <a>Home ›</a>
                </Link>
                <span>Search results for: {searchKey}</span>
              </div>
              <h2 className={styles.title}>Search results for: {searchKey}</h2>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default BlogHeroSimple;
